import httpClient from '@syneto/http-client';
import { jobEndpoints, partnerPreviewEndpoints } from './endpoints';

const ENROLLMENT_UPDATE_FAILED_MESSAGE = 'Failed to update Partner Preview enrollment.';
const ENROLLMENT_UPDATE_SUCCEEDED_MESSAGE = 'Partner Preview enrollment updated successfully.';

export const ACCESS_REQUEST_STATUS = {
	NOT_REQUESTED: 'notRequested',
	PENDING: 'pending',
	ENROLLED: 'enrolled',
};

export class PartnerPreviewService {
	constructor(restAxios) {
		this.restAxios = restAxios;
	}

	getParticipation = (companyId) => {
		return this.restAxios.get(partnerPreviewEndpoints.participations, { params: { companyId } })
			.then((response) => {
				const [participation] = response.data ?? [];
				return participation ?? { enabled: false };
			})
			.catch((error) => {
				if (error?.response?.status === 404) {
					return { enabled: false };
				}
				throw error;
			});
	};

	// No params on GET and no body on POST: the company, and for POST the requester, are both
	// derived server-side from the logged in user's identity (SYN-3056). The hub never sends
	// companyId or userId on either call.
	getAccessRequest = () => {
		return this.restAxios.get(partnerPreviewEndpoints.accessRequest)
			.then((response) => {
				return response.data;
			});
	};

	requestAccess = () => {
		return this.restAxios.post(partnerPreviewEndpoints.accessRequest)
			.then((response) => {
				return response.data;
			});
	};

	getEnrollments = (companyId, start = 0, limit = 15) => {
		return this.restAxios.get(partnerPreviewEndpoints.enrollments, { params: { companyId, start, limit } })
			.then((response) => {
				return response.data;
			});
	};

	setEnrollment = (enrollmentId, enabled, userId) => {
		return this.restAxios.patch(partnerPreviewEndpoints.enrollment(enrollmentId), { enabled, userId })
			.then((response) => {
				return response.data;
			});
	};

	createEnrollment = (productId, enabled, userId) => {
		return this.restAxios.post(partnerPreviewEndpoints.enrollments, { productId, enabled, userId })
			.then((response) => {
				return response.data;
			});
	};

	pollJob = (jobId) => {
		return new Promise((resolve, reject) => {
			const poll = httpClient.poll(
				jobEndpoints.job(jobId),
				{
					runAtOnce: true
				},
				(response) => {
					const task = response?.data;
					if (typeof task?.status !== 'string') {
						poll.cancel();
						reject(ENROLLMENT_UPDATE_FAILED_MESSAGE);
						return;
					}

					if (task.status.toLowerCase() === 'failed') {
						poll.cancel();
						reject(task.statusMessage || ENROLLMENT_UPDATE_FAILED_MESSAGE);
					}
					if (task.status.toLowerCase() === 'succeeded') {
						poll.cancel();
						resolve(task.statusMessage || ENROLLMENT_UPDATE_SUCCEEDED_MESSAGE);
					}
				},
				(error) => {
					poll.cancel();
					reject(error?.response?.data?.detail || ENROLLMENT_UPDATE_FAILED_MESSAGE);
				}
			);
		});
	};
}
